module.exports = __webpack_public_path__ + "img/adminServiceInfo1.0a141dc8.png";